<div class="flex flex-col gap-6 py-6">
  @for (kpiSection of sections(); track kpiSection.section) {
    <div
      class="kpi-cards-container flex flex-col gap-3"
      [attr.data-testid]="'admin-event-analytics-kpi-section-' + kpiSection.section"
    >
      <h4 class="text-xs uppercase tracking-wide text-shikenso-purple-base-60">
        {{ 'pages.admin.eventAnalytics.sections.' + kpiSection.section | translate }}
      </h4>

      <div class="kpi-cards-grid grid grid-cols-1 sm:grid-cols-2 gap-4">
        @for (card of kpiSection.cards; track card.config.key) {
          <app-event-kpi-card
            [attr.data-testid]="'admin-event-analytics-kpi-card-' + card.config.key"
            [title]="'pages.admin.eventAnalytics.kpis.' + card.config.key + '.title' | translate"
            [infoMessage]="'pages.admin.eventAnalytics.kpis.' + card.config.key + '.info' | translate"
            [valueType]="card.config.valueType"
            [currentValue]="card.currentValue"
            [totalValue]="card.totalValue"
            [comparedCurrentValue]="card.comparedCurrentValue"
            [enableProgressBar]="!!card.config.enableProgressBar"
            [lowerIsBetter]="!!card.config.lowerIsBetter"
            [comparing]="store.isComparing$()"
            [loading]="store.kpisLoading$()"
          />
        }
      </div>
    </div>
  }
</div>
